
export const hardReload = (replace?: string) => {
  if (typeof window !== "undefined") {
    window.location.reload();
    if (replace) {
      window.location.replace(replace)
    }
  }
}